import api from '../api';

const userService = {
    // Get all users (for team invitations)
    // Accepts optional params: { team_id } to exclude existing team members
    list: (params = {}) => api.get('/users', { params }),

    // Search users with pagination — returns { data: { users, meta: { current_page, last_page, has_more } } }
    search: (query = '', page = 1, perPage = 20) =>
        api.get('/users/search', { params: { query, page, per_page: perPage } }),
};

export default userService;
